import _uniqBy from 'lodash/uniqBy'
import _sortBy from 'lodash/sortBy'

const initialState = {
  loading: false,
  records: {}
}

const itemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PRODUCTS_FETCH_START':
    case 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_START':
    case 'PRODUCT_AVAILABILITIES_FETCH_START':
    case 'PRODUCT_PRICES_FETCH_START':
    case 'PRODUCT_IMAGES_FETCH_START':
      return {
        ...state,
        loading: true
      }
    case 'PRODUCTS_FETCH_ERROR':
    case 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_ERROR':
    case 'PRODUCT_AVAILABILITIES_FETCH_ERROR':
    case 'PRODUCT_PRICES_FETCH_ERROR':
    case 'PRODUCT_IMAGES_FETCH_ERROR':
      return {
        ...state,
        loading: false
      }
    // Fetching products
    case 'PRODUCTS_FETCH_SUCCESS': {
      const records = action.payload.records.reduce((state, item) => {
        const existing = state[item.id]

        if (existing) {
          return {
            ...state,
            [item.id]: {
              ...existing,
              ...item
            }
          }
        }

        return {
          ...state,
          [item.id]: item
        }
      }, state.records)

      return {
        loading: false,
        records
      }
    }
    // Fetching product availabilities
    case 'PRODUCT_AVAILABILITIES_FETCH_SUCCESS': {
      const records = action.payload.records.reduce((state, availability) => {
        const existing = state[availability.item_id]

        if (existing) {
          return {
            ...state,
            [availability.item_id]: {
              ...existing,
              availability
            }
          }
        }

        return {
          ...state,
          [availability.item_id]: {
            id: availability.item_id,
            availability
          }
        }
      }, state.records)

      return {
        loading: false,
        records
      }
    }
    // Fetching product variation availabilities
    case 'PRODUCT_VARIATION_AVAILABILITIES_FETCH_SUCCESS': {
      const records = action.payload.records.reduce((state, availability) => {
        const existing = state[action.payload.productId]

        if (existing) {
          const products = existing.products.map((product) => {
            if (product.id === availability.item_id) {
              return {
                ...product,
                availability
              }
            }

            return product
          })

          return {
            ...state,
            [action.payload.productId]: {
              ...existing,
              products
            }
          }
        }

        return {
          ...state,
          [action.payload.productId]: {
            id: action.payload.productId,
            products: [
              {
                id: availability.item_id,
                availability
              }
            ]
          }
        }
      }, state.records)

      return {
        loading: false,
        records
      }
    }
    // Fetching product prices
    case 'PRODUCT_PRICES_FETCH_SUCCESS': {
      const records = action.payload.records.reduce((state, price) => {
        const existing = state[price.item_id]

        if (existing) {
          return {
            ...state,
            [price.item_id]: {
              ...existing,
              price
            }
          }
        }

        return {
          ...state,
          [price.item_id]: {
            id: price.item_id,
            price
          }
        }
      }, state.records)

      return {
        loading: false,
        records
      }
    }
    // Fetching product images
    case 'PRODUCT_IMAGES_FETCH_SUCCESS': {
      const records = action.payload.records.reduce((state, image) => {
        const existing = state[image.owner_id]

        if (existing) {
          return {
            ...state,
            [image.owner_id]: {
              ...existing,
              photos: _sortBy(_uniqBy([...existing.photos, image], 'id'), 'position')
            }
          }
        }

        return {
          ...state,
          [image.owner_id]: {
            id: image.owner_id,
            photos: [image]
          }
        }
      }, state.records)

      return {
        loading: false,
        records
      }
    }
    // Updating product variation
    case 'PRODUCT_UPDATE_VARIATION': {
      const { id, variationId } = action.payload

      const records = { ...state.records, [id]: { ...state.records[id], variation_id: variationId } }

      return {
        ...state,
        records
      }
    }
    // Set error if no variation
    case 'PRODUCT_VARIATION_ERROR': {
      const { id, value } = action.payload

      const records = { ...state.records, [id]: { ...state.records[id], error: value } }

      return {
        ...state,
        records
      }
    }
    // Updating product configuration
    case 'PRODUCT_UPDATE_CONFIGURATION': {
      const { id, itemId, variationId } = action.payload

      const records = {
        ...state.records,
        [id]: {
          ...state.records[id],
          configuration: {
            ...state.records[id].configuration,
            [itemId]: variationId
          }
        }
      }

      return {
        ...state,
        records
      }
    }
    // Updating bundle errors
    case 'PRODUCT_BUNDLE_ERROR': {
      const { id, value } = action.payload

      const records = { ...state.records, [id]: { ...state.records[id], variant_error: value } }

      return {
        ...state,
        records
      }
    }
    default:
      return state
  }
}

export default itemsReducer
